(function () {

    function getPrefix(title) {

        switch (title.toLowerCase()) {

            case "coral blush pink":
                return "pink";

            case "chlorophyll green":
                return "green";

            case "oceania blue":
                return "blue";

              case "oyster shell":
                return "oyster"

            case "graphite sand":
                return "graphite";

            case "seed pearl":
                return "pearl";

            case "mocha mousse":
                return "mocha";

            case "lemon burst":
                return "yellow";

                  case "red crown tail":
                return "red";

            case "glacier white":
                return "white";

            case "orange":
                return "orange";

            case "violet":
                return "violet";

                case "limpet shell blue":
                     return "limpet";

          

            default:
                return "";

        }

    }

    function filterGallery() {

        const checked = document.querySelector(
            'fieldset input[type="radio"]:checked'
        );

        if (!checked) return;

        const prefix = getPrefix(checked.value.trim().replace(/\s+/g, " "));

        if (!prefix) return;

        //------------------------
        // MAIN IMAGES
        //------------------------

        document.querySelectorAll(".product__media-item").forEach((item) => {

            const img = item.querySelector("img");

            if (!img) return;

            item.style.display = img.alt.toLowerCase().startsWith(prefix)
                ? ""
                : "none";

        });

        //------------------------
        // THUMBNAILS
        //------------------------

        document.querySelectorAll(".thumbnail-list__item").forEach((item) => {

            const img = item.querySelector("img");

            if (!img) return;

            item.style.display = img.alt.toLowerCase().startsWith(prefix)
                ? ""
                : "none";

        });
// ------------------------------------
// Activate first visible media smoothly
// ------------------------------------

requestAnimationFrame(() => {

    const gallery = document.querySelector("media-gallery");

    if (!gallery || typeof gallery.setActiveMedia !== "function") return;

    const firstVisibleSlide = gallery.querySelector(
        '.product__media-item:not([style*="display: none"])'
    );

    if (!firstVisibleSlide) return;

    // Already active? Nothing to do.
    if (firstVisibleSlide.classList.contains("is-active")) return;

    gallery.setActiveMedia(firstVisibleSlide.dataset.mediaId, false);

});

const gallery = document.querySelector("media-gallery");

if (
    gallery &&
    gallery.elements &&
    gallery.elements.viewer &&
    gallery.elements.viewer.slider
) {

    gallery.elements.viewer.resetPages();

    gallery.elements.viewer.slider.scrollTo({
        left: 0
    });

}
    }

    //------------------------
    // Initial
    //------------------------

    document.addEventListener("DOMContentLoaded", () => {

         // Mark image as loaded
    document.querySelectorAll(".product__media-item img").forEach(img => {

        const container = img.closest(".product-media-container");

        if (img.complete) {
            container?.classList.add("loaded");
        }

        img.addEventListener("load", () => {
            container?.classList.add("loaded");
        });

    });

    setTimeout(filterGallery, 300);

    });

    //------------------------
    // Variant change
    //------------------------

    document.addEventListener("change", function (e) {

        if (e.target.matches('input[type="radio"]')) {

            setTimeout(filterGallery, 400);

            /*
             * Keep Shopify's Add to Cart variant ID in sync with the
             * colour selected by the customer.
             */
            setTimeout(function () {
                const variantId = new URLSearchParams(window.location.search).get("variant");

                if (!variantId) return;

                document.querySelectorAll(
                    'product-info input[name="id"], form[action*="/cart/add"] input[name="id"]'
                ).forEach(function (input) {
                    input.value = variantId;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                });
            }, 1200);

        }

    });

    //------------------------
    // Craft AJAX refresh
    //------------------------

    document.addEventListener("variant:change", function () {

        setTimeout(filterGallery, 300);

    });

    document.addEventListener("shopify:section:load", function () {

        setTimeout(filterGallery, 300);

    });

})();